
const common = {
  // Navigation
  home: 'Home',
  about: 'About',
  services: 'Services',
  projects: 'Projects',
  team: 'Team',
  testimonials: 'Testimonials',
  contact: 'Contact',
  
  // Hero Section
  heroTitle: 'Puzzle: We Create Safe and Inspiring Environments for Children',
  heroSubtitle: 'Specialists in designing and equipping nurseries, kindergartens, special centers, and outdoor areas',
  
  // Hero Slides
  heroSlide1Title: 'Puzzle: We Create Safe and Inspiring Environments for Children',
  heroSlide1Subtitle: 'Specialists in designing and equipping nurseries, kindergartens, special centers, and outdoor areas',
  heroSlide2Title: '3D Design for Your Project',
  heroSlide2Subtitle: 'See your project realistically before implementation - We provide professional 3D visualizations showing all details',
  
  viewProjects: 'View Projects',
  freeConsultation: 'Consultation & Assessment',
  
  // About Section
  aboutTitle: 'About Puzzle',
  aboutDescription: 'Puzzle is a leading Saudi brand specialized in designing and implementing safe and inspiring educational and recreational environments for children. We believe that every child deserves an environment that stimulates their creativity and develops their skills.',
  
  // Specializations
  specializationsTitle: 'Our Specialization Areas',
  nurserySetup: 'Nursery Setup',
  kindergartenSetup: 'Kindergarten Setup',
  specialCenters: 'Special Centers',
  playrooms: 'Play Areas',
  outdoorAreas: 'Outdoor Areas',
  
  // Services
  servicesTitle: 'Our Services',
  service1Title: '3D Project Design',
  service1Description: 'Realistic 3D visualization showing project appearance before implementation for nurseries, centers, and playgrounds',
  service2Title: 'Nursery & Kindergarten Setup',
  service2Description: 'Comprehensive implementation of safe furniture, toys, and decor with quality standards compliance',
  service3Title: 'Special Centers Setup',
  service3Description: 'Design and implementation of occupational and sensory therapy rooms equipped with interactive educational toys',
  service4Title: 'Children\'s Play Area Setup',
  service4Description: 'Design of interactive indoor home and educational environments',
  service5Title: 'Playground & Recreation Centers Setup',
  service5Description: 'Implementation of safe outdoor play areas equipped with rubber flooring',
  
  // Social Responsibility
  socialResponsibilityTitle: 'Our Social Responsibility',
  socialResponsibilitySubtitle: 'We believe in our role in serving the community and developing educational environments for children throughout the Kingdom',
  charityNurseries: 'Puzzle Charity Nurseries Initiative',
  charityNurseriesDesc: 'We provide free design and setup services for charity nurseries to support children in need',
  professionalTraining: 'Professional Training Program',
  professionalTrainingDesc: 'We offer free training programs for Saudi youth in educational environment design',
  knowledgeSharing: 'Knowledge Sharing',
  knowledgeSharingDesc: 'We organize workshops and awareness lectures for specialists in early childhood care',
  environmentalSustainability: 'Environmental Sustainability',
  environmentalSustainabilityDesc: 'We are committed to using eco-friendly materials and energy-efficient technologies in all our projects',
  
  // Projects
  projectsTitle: 'Our Projects',
  beforeAfter: 'Witness the Amazing Transformation - Before & After',
  projectsSubtitle: 'From ordinary spaces to inspiring environments that stimulate creativity and learning',
  
  // Team
  teamTitle: 'Puzzle Team',
  teamDescription: 'A specialized team of designers, engineers, and implementers working with creativity and collaboration',
  teamMember1Name: 'Ahmed Mohammed Al-Ahmad',
  teamMember1Position: 'CEO & Company Founder',
  teamMember1Bio: '15 years of experience in designing educational and recreational environments for children',
  teamMember2Name: 'Fatima Salem Al-Otaibi',
  teamMember2Position: 'Interior Design Manager',
  teamMember2Bio: 'Specialist in interior design for nurseries and educational centers',
  teamMember3Name: 'Khalid Abdullah Al-Nuaimi',
  teamMember3Position: 'Implementation & Supervision Engineer',
  teamMember3Bio: 'Civil engineer specialized in implementing educational and recreational projects',
  teamMember4Name: 'Nora Ahmed Al-Zahrani',
  teamMember4Position: 'Child Psychology Specialist',
  teamMember4Bio: 'Expert in designing educational environments suitable for child development',
  
  // Testimonials
  testimonialsTitle: 'Client Testimonials',
  testimonialsSubtitle: 'What our clients say about our services and work quality',
  testimonial1Text: 'Puzzle transformed our nursery into a wonderful and stimulating place for children. The design and implementation were excellent and the children love the new space.',
  testimonial1Name: 'Sarah Ahmed',
  testimonial1Position: 'Director of Future Buds Nursery',
  testimonial2Text: 'Working with Puzzle team was an amazing experience. Their attention to detail and high quality made our special center a perfect place for children with special needs.',
  testimonial2Name: 'Mohammed Al-Ghamdi',
  testimonial2Position: 'Director of Al-Noor Rehabilitation Center',
  testimonial3Text: 'The outdoor playground design for our school was creative and innovative. Children enjoy playing in a safe and beautiful environment.',
  testimonial3Name: 'Hind Al-Otaibi',
  testimonial3Position: 'Director of Al-Amal Elementary School',
  
  // Contact
  contactTitle: 'Contact Us',
  contactSubtitle: 'We are here to help you achieve your vision for an ideal educational and recreational environment',
  name: 'Name',
  organization: 'Organization / Company Name',
  phone: 'Phone',
  email: 'Email',
  projectType: 'Project Type',
  city: 'Region / City',
  country: 'Country',
  clientType: 'Client Type',
  individual: 'Individual',
  companyOrg: 'Organization / Company',
  message: 'Message',
  send: 'Send',
  contactInfo: 'Contact Information',
  address: 'Address',
  addressValue: 'Riyadh, Saudi Arabia',
  phoneValue: '+966 50 123 4567',
  emailValue: 'info@puzzle-sa.com',
  workingHours: 'Working Hours',
  workingHoursValue: 'Sunday - Thursday: 8:00 AM - 6:00 PM',
  
  // Footer
  footerDescription: 'Puzzle Saudi Arabia - Leading company in designing and implementing safe and inspiring educational and recreational environments for children',
  quickLinks: 'Quick Links',
  privacyPolicy: 'Privacy Policy',
  followUs: 'Follow Us',
  allRightsReserved: 'All Rights Reserved',
  
  // Common Actions
  learnMore: 'Learn More',
  serviceDetails: 'Service Details',
  getQuote: 'Get Quote',
  viewAll: 'View All',
  readMore: 'Read More',
  
  // Form placeholders
  namePlaceholder: 'Enter your full name',
  organizationPlaceholder: 'Organization or institution name',
  phonePlaceholder: 'Phone number',
  emailPlaceholder: 'Email address',
  messagePlaceholder: 'Write your message here...',
  
  // Project types
  nursery: 'Nursery or Kindergarten',
  specialCenter: 'Special Center',
  playroom: 'Play Area',
  gameRoom: 'Game Room',
  outdoorArea: 'Outdoor Area',
  other: 'Other',
  
  // Budget
  budgetRange: 'Expected Budget Range',

  // Locations
  selectCountry: 'Select Country',
  searchCountry: 'Search country...',
  selectCity: 'Select Region / City',
  searchCity: 'Search region...',
  loadingLocations: 'Loading...',
  noResultsFound: 'No results found',
  selectCountryFirst: 'Select a country first',
  
  // API Error Messages
  apiRequestFailed: 'API request failed',
  connectionError: 'Connection error with server',
  serverError: 'Server error occurred',
  
  // Form Messages
  formSuccessMessage: 'Your message has been sent successfully! We will contact you soon.',
  formErrorMessage: 'An error occurred while sending the message. Please try again.',
  sending: 'Sending...',
  sendUsMessage: 'Send us a message',
  sendUsMessageDescription: 'We are here to help you. Fill out the form and we will contact you soon.',
  formConsentPrefix: 'By submitting this form, you agree to the',
  formConsentLink: 'Privacy Policy & Terms of Use',
  invalidSaudiPhone: 'Please enter a valid Saudi phone number',
  invalidEmail: 'Please enter a valid email address',
  
  // Success Page
  successPageTitle: '🎉 Thank You for Contacting Us!',
  successPageSubtitle: 'Your message has been received successfully',
  successPageDescription: 'Our team will review your request and contact you within 24 hours',
  successPageCallUs: 'Or call us now on our unified number',
  successPageFollowUs: 'Follow us on social media',
  successPageBackHome: 'Back to Home',
  successPageViewProjects: 'View Our Projects',
  successPageThankYou: 'We appreciate your trust and look forward to working with you to create a safe and inspiring environment for your children',
  
  // Services Page
  ourMainServices: 'Our Main Services',
  workProcess: 'Work Process',
  workProcessDescription: 'We follow a clear and organized methodology to ensure your project is executed with the highest quality',
  comprehensiveSolutions: 'Comprehensive and integrated solutions for designing and implementing educational and recreational environments',
  readyToStart: 'Ready to Start Your Project?',
  contactForQuote: 'Contact us today for a consultation & assessment and customized quote for your project',
  viewOurProjects: 'View Our Projects',
  
  // Linktree Page
  followOnAllPlatforms: 'Follow us on all platforms',
  shopNow: 'Shop Now',
  technicalSupport: 'Technical Support',
  salesTeam: 'Sales Department',
  supportPhone: 'Support Phone',
  salesPhones: 'Sales Numbers',
  
  // Image Modal
  imageModalHint: 'Click anywhere or press ESC to close',

  // Playroom Landing Page
  playroomLandingTitle: 'The Perfect Play Area for Your Child',
  playroomLandingSubtitle: 'We transform any space into a safe, magical world',
  playroomLandingHeroDesc: 'Professional design and complete execution for children\'s play areas — from concept to reality with quality and safety guaranteed.',
  playroomLandingCTA: 'Get a Consultation & Assessment',
  playroomLandingFormTitle: 'Request a Free Quote',
  playroomLandingFormDesc: 'Tell us about your space and we\'ll start designing your child\'s dream room.',
  playroomLandingBeforeAfterTitle: 'Before & After — See the Transformation',
  playroomLandingBeforeAfterSubtitle: 'Real projects executed by the Puzzle team across Saudi Arabia',
  playroomLandingBefore: 'Before',
  playroomLandingAfter: 'After',
  playroomLandingWhyUs: 'Why Puzzle?',
  playroomLandingWhyUsSubtitle: 'Experience that speaks through results',
  playroomLandingFeat1Title: '3D Design',
  playroomLandingFeat1Desc: 'See your child\'s room before execution with realistic 3D designs',
  playroomLandingFeat2Title: 'Certified Safe Materials',
  playroomLandingFeat2Desc: 'We use child-friendly materials free from harmful substances',
  playroomLandingFeat3Title: 'Complete Execution',
  playroomLandingFeat3Desc: 'From décor to toys and furniture — everything handled in one place',
  playroomLandingFeat4Title: 'After-Delivery Warranty',
  playroomLandingFeat4Desc: 'Continuous support and follow-up after your project is delivered',
  playroomLandingCallout: 'Start Transforming Your Space Today',
  playroomLandingCalloutCTA: 'Contact Us Now',
  playroomLandingProjectsTitle: 'Our Playroom Projects',
  playroomLandingProjectsSubtitle: 'Every project is a new success story',
  playroomLandingStep1: 'Consultation & Assessment',
  playroomLandingStep1Desc: 'We listen to your idea, assess the space, and provide expert recommendations',
  playroomLandingStep2: 'Custom Design',
  playroomLandingStep2Desc: 'We design in 3D tailored to your space and budget',
  playroomLandingStep3: 'Professional Execution',
  playroomLandingStep3Desc: 'Our team executes with precision and on time',
  playroomLandingStep4: 'Delivery & Follow-up',
  playroomLandingStep4Desc: 'We deliver the project and follow up on your satisfaction',

  // Play Areas Service Details Page
  playAreasPageSeoTitle: 'Puzzle - Play Areas Setup Service',
  playAreasPageSeoDescription: 'Detailed page for Puzzle play areas setup service: 3D design, safe execution, certified materials, and complete indoor/outdoor implementation.',
  playAreasPageSeoKeywords: 'play areas setup, kids play areas design, indoor and outdoor play areas, Puzzle Saudi Arabia',
  playAreasPageTag: 'Service Details',
  playAreasPageTitle: 'Play Areas Setup Service',
  playAreasPageHeroSubtitle: 'Integrated indoor and outdoor solutions with high safety standards',
  playAreasPageHeroDescription: 'We design and execute practical and attractive play areas tailored to the target age group and built for safe, fun play experiences.',
  playAreasPagePrimaryCta: 'Start Your Project',
  playAreasPageSecondaryCta: 'View Similar Projects',
  playAreasPageHighlightsTitle: 'What Do We Deliver?',
  playAreasPageHighlightsSubtitle: 'From concept to handover with close follow-up at every stage',
  playAreasPageHighlight1Title: '3D Design Before Execution',
  playAreasPageHighlight1Desc: 'We provide a clear visual concept before implementation to speed up decisions.',
  playAreasPageHighlight2Title: 'Certified Safety & Quality',
  playAreasPageHighlight2Desc: 'We select child-appropriate materials and apply strict safety requirements.',
  playAreasPageHighlight3Title: 'Professional Installation',
  playAreasPageHighlight3Desc: 'A specialized team installs flooring, equipment, and furniture with precision.',
  playAreasPageHighlight4Title: 'Budget-Fit Solutions',
  playAreasPageHighlight4Desc: 'Flexible options that deliver strong outcomes within your available budget.',
  playAreasPageProjectsTitle: 'Sample Play Areas',
  playAreasPageProjectsSubtitle: 'Real projects delivered by the Puzzle team across multiple sites',
  playAreasPageProcessTitle: 'How We Work',
  playAreasPageProcessSubtitle: '4 clear steps to deliver the best result',
  playAreasPageStep1Title: 'Site & Needs Assessment',
  playAreasPageStep1Desc: 'We define space constraints, age group needs, and project goals.',
  playAreasPageStep2Title: 'Design & Approval',
  playAreasPageStep2Desc: 'We prepare a 3D concept and suitable options before final approval.',
  playAreasPageStep3Title: 'Preparation & Execution',
  playAreasPageStep3Desc: 'We execute based on a clear schedule with quality monitoring.',
  playAreasPageStep4Title: 'Handover & Follow-up',
  playAreasPageStep4Desc: 'We deliver a ready-to-use area and provide post-delivery support.',
  playAreasPageFinalTitle: 'Ready to transform your space into a standout play area?',
  playAreasPageFinalDesc: 'Contact Puzzle now for consultation, assessment, and a tailored quote.'
};

export default common;
